module.exports = __webpack_public_path__ + "img/vg.62926b87.png";